/**
 * @file AccountStatements.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from 'react';
import Widget from '../../widgets/Widget';
import '../../../../styles/account-statements.css';

function AccountStatements() {
    return (
        <Widget name={"account-statements"}>
            <div className="heading">
                <h1 className="title">Account Statements</h1>
            </div>
            <div className="mt-10">
                <div className="statement">
                    <div className="flex justify-between">
                        <div className="flex">
                            <img src="/assets/icons/reports/statement.svg" className="statement-icon" />
                            <div className="weekly-report">
                                September 2023
                                <span>09/05/2023</span>
                            </div>
                            <div className="pdf-btn">
                                PDF
                            </div>
                        </div>
                        <div className="download-btn">
                            <img src="/assets/icons/reports/icon-cloud-download-gray.svg" />
                            Download
                        </div>
                    </div>
                </div>
                <div className="statement">
                    <div className="flex justify-between">
                        <div className="flex">
                            <img src="/assets/icons/reports/statement.svg" className="statement-icon" />
                            <div className="weekly-report">
                                August 2023
                                <span>08/05/2023</span>
                            </div>
                            <div className="pdf-btn">
                                PDF
                            </div>
                        </div>
                        <div className="download-btn">
                            <img src="/assets/icons/reports/icon-cloud-download-gray.svg" />
                            Download
                        </div>
                    </div>
                </div>
                <div className="statement">
                    <div className="flex justify-between">
                        <div className="flex">
                            <img src="/assets/icons/reports/statement.svg" className="statement-icon" />
                            <div className="weekly-report">
                                July 2023
                                <span>07/05/2023</span>
                            </div>
                            <div className="pdf-btn">
                                PDF
                            </div>
                        </div>
                        <div className="download-btn">
                            <img src="/assets/icons/reports/icon-cloud-download-gray.svg" />
                            Download
                        </div>
                    </div>
                </div>
                <div className="view-all">
                    <span className="cursor-pointer">Show all</span>
                </div>
            </div>
        </Widget>
    )
}

export default AccountStatements